import { Button, styled } from "@mui/material";

export const TransparentButton = styled(Button)(() => ({
  border: "none",
  backgroundColor: "transparent",
}));
